module.exports = __webpack_public_path__ + "static/media/InDesign.22906791.svg";